export default {
  '0': 'address-book',
  '1': 'address-book-o',
  '2': 'address-card',
  '3': 'address-card-o',
  '4': 'bandcamp',
  '5': 'bath',
  '6': 'bathtub',
  '7': 'drivers-license',
  '8': 'drivers-license-o',
  '9': 'eercast',
  '10': 'envelope-open',
  '11': 'envelope-open-o',
  '12': 'etsy',
  '13': 'free-code-camp',
  '14': 'grav',
  '15': 'handshake-o',
  '16': 'id-badge',
  '17': 'id-card',
  '18': 'id-card-o',
  '19': 'imdb',
  '20': 'linode',
  '21': 'meetup',
  '22': 'microchip',
  '23': 'podcast',
  '24': 'quora',
  '25': 'ravelry',
  '26': 's15',
  '27': 'shower',
  '28': 'snowflake-o',
  '29': 'superpowers',
  '30': 'telegram',
  '31': 'thermometer',
  '32': 'thermometer-0',
  '33': 'thermometer-1',
  '34': 'thermometer-2',
  '35': 'thermometer-3',
  '36': 'thermometer-4',
  '37': 'thermometer-empty',
  '38': 'thermometer-full',
  '39': 'thermometer-half',
  '40': 'thermometer-quarter',
  '41': 'thermometer-three-quarters',
  '42': 'times-rectangle',
  '43': 'times-rectangle-o',
  '44': 'user-circle',
  '45': 'user-circle-o',
  '46': 'user-o',
  '47': 'vcard',
  '48': 'vcard-o',
  '49': 'window-close',
  '50': 'window-close-o',
  '51': 'window-maximize',
  '52': 'window-minimize',
  '53': 'window-restore',
  '54': 'wpexplorer',
  '55': 'address-book',
  '56': 'address-book-o',
  '57': 'address-card',
  '58': 'address-card-o',
  '59': 'adjust',
  '60': 'american-sign-language-interpreting',
  '61': 'anchor',
  '62': 'archive',
  '63': 'area-chart',
  '64': 'arrows',
  '65': 'arrows-h',
  '66': 'arrows-v',
  '67': 'asl-interpreting',
  '68': 'assistive-listening-systems',
  '69': 'asterisk',
  '70': 'at',
  '71': 'audio-description',
  '72': 'automobile',
  '73': 'balance-scale',
  '74': 'ban',
  '75': 'bank',
  '76': 'bar-chart',
  '77': 'bar-chart-o',
  '78': 'barcode',
  '79': 'bars',
  '80': 'bath',
  '81': 'bathtub',
  '82': 'battery',
  '83': 'battery-0',
  '84': 'battery-1',
  '85': 'battery-2',
  '86': 'battery-3',
  '87': 'battery-4',
  '88': 'battery-empty',
  '89': 'battery-full',
  '90': 'battery-half',
  '91': 'battery-quarter',
  '92': 'battery-three-quarters',
  '93': 'bed',
  '94': 'beer',
  '95': 'bell',
  '96': 'bell-o',
  '97': 'bell-slash',
  '98': 'bell-slash-o',
  '99': 'bicycle',
  '100': 'binoculars',
  '101': 'birthday-cake',
  '102': 'blind',
  '103': 'bluetooth',
  '104': 'bluetooth-b',
  '105': 'bolt',
  '106': 'bomb',
  '107': 'book',
  '108': 'bookmark',
  '109': 'bookmark-o',
  '110': 'braille',
  '111': 'briefcase',
  '112': 'bug',
  '113': 'building',
  '114': 'building-o',
  '115': 'bullhorn',
  '116': 'bullseye',
  '117': 'bus',
  '118': 'cab',
  '119': 'calculator',
  '120': 'calendar',
  '121': 'calendar-check-o',
  '122': 'calendar-minus-o',
  '123': 'calendar-o',
  '124': 'calendar-plus-o',
  '125': 'calendar-times-o',
  '126': 'camera',
  '127': 'camera-retro',
  '128': 'car',
  '129': 'caret-square-o-down',
  '130': 'caret-square-o-left',
  '131': 'caret-square-o-right',
  '132': 'caret-square-o-up',
  '133': 'cart-arrow-down',
  '134': 'cart-plus',
  '135': 'cc',
  '136': 'certificate',
  '137': 'check',
  '138': 'check-circle',
  '139': 'check-circle-o',
  '140': 'check-square',
  '141': 'check-square-o',
  '142': 'child',
  '143': 'circle',
  '144': 'circle-o',
  '145': 'circle-o-notch',
  '146': 'circle-thin',
  '147': 'clock-o',
  '148': 'clone',
  '149': 'close',
  '150': 'cloud',
  '151': 'cloud-download',
  '152': 'cloud-upload',
  '153': 'code',
  '154': 'code-fork',
  '155': 'coffee',
  '156': 'cog',
  '157': 'cogs',
  '158': 'comment',
  '159': 'comment-o',
  '160': 'commenting',
  '161': 'commenting-o',
  '162': 'comments',
  '163': 'comments-o',
  '164': 'compass',
  '165': 'copyright',
  '166': 'creative-commons',
  '167': 'credit-card',
  '168': 'credit-card-alt',
  '169': 'crop',
  '170': 'crosshairs',
  '171': 'cube',
  '172': 'cubes',
  '173': 'cutlery',
  '174': 'dashboard',
  '175': 'database',
  '176': 'deaf',
  '177': 'deafness',
  '178': 'desktop',
  '179': 'diamond',
  '180': 'dot-circle-o',
  '181': 'download',
  '182': 'drivers-license',
  '183': 'drivers-license-o',
  '184': 'edit',
  '185': 'ellipsis-h',
  '186': 'ellipsis-v',
  '187': 'envelope',
  '188': 'envelope-o',
  '189': 'envelope-open',
  '190': 'envelope-open-o',
  '191': 'envelope-square',
  '192': 'eraser',
  '193': 'exchange',
  '194': 'exclamation',
  '195': 'exclamation-circle',
  '196': 'exclamation-triangle',
  '197': 'external-link',
  '198': 'external-link-square',
  '199': 'eye',
  '200': 'eye-slash',
  '201': 'eyedropper',
  '202': 'fax',
  '203': 'feed',
  '204': 'female',
  '205': 'fighter-jet',
  '206': 'file-archive-o',
  '207': 'file-audio-o',
  '208': 'file-code-o',
  '209': 'file-excel-o',
  '210': 'file-image-o',
  '211': 'file-movie-o',
  '212': 'file-pdf-o',
  '213': 'file-photo-o',
  '214': 'file-picture-o',
  '215': 'file-powerpoint-o',
  '216': 'file-sound-o',
  '217': 'file-video-o',
  '218': 'file-word-o',
  '219': 'file-zip-o',
  '220': 'film',
  '221': 'filter',
  '222': 'fire',
  '223': 'fire-extinguisher',
  '224': 'flag',
  '225': 'flag-checkered',
  '226': 'flag-o',
  '227': 'flash',
  '228': 'flask',
  '229': 'folder',
  '230': 'folder-o',
  '231': 'folder-open',
  '232': 'folder-open-o',
  '233': 'frown-o',
  '234': 'futbol-o',
  '235': 'gamepad',
  '236': 'gavel',
  '237': 'gear',
  '238': 'gears',
  '239': 'gift',
  '240': 'glass',
  '241': 'globe',
  '242': 'graduation-cap',
  '243': 'group',
  '244': 'hand-grab-o',
  '245': 'hand-lizard-o',
  '246': 'hand-paper-o',
  '247': 'hand-peace-o',
  '248': 'hand-pointer-o',
  '249': 'hand-rock-o',
  '250': 'hand-scissors-o',
  '251': 'hand-spock-o',
  '252': 'hand-stop-o',
  '253': 'handshake-o',
  '254': 'hard-of-hearing',
  '255': 'hashtag',
  '256': 'hdd-o',
  '257': 'headphones',
  '258': 'heart',
  '259': 'heart-o',
  '260': 'heartbeat',
  '261': 'history',
  '262': 'home',
  '263': 'hotel',
  '264': 'hourglass',
  '265': 'hourglass-1',
  '266': 'hourglass-2',
  '267': 'hourglass-3',
  '268': 'hourglass-end',
  '269': 'hourglass-half',
  '270': 'hourglass-o',
  '271': 'hourglass-start',
  '272': 'i-cursor',
  '273': 'id-badge',
  '274': 'id-card',
  '275': 'id-card-o',
  '276': 'image',
  '277': 'inbox',
  '278': 'industry',
  '279': 'info',
  '280': 'info-circle',
  '281': 'institution',
  '282': 'key',
  '283': 'keyboard-o',
  '284': 'language',
  '285': 'laptop',
  '286': 'leaf',
  '287': 'legal',
  '288': 'lemon-o',
  '289': 'level-down',
  '290': 'level-up',
  '291': 'life-bouy',
  '292': 'life-buoy',
  '293': 'life-ring',
  '294': 'life-saver',
  '295': 'lightbulb-o',
  '296': 'line-chart',
  '297': 'location-arrow',
  '298': 'lock',
  '299': 'low-vision',
  '300': 'magic',
  '301': 'magnet',
  '302': 'mail-forward',
  '303': 'mail-reply',
  '304': 'mail-reply-all',
  '305': 'male',
  '306': 'map',
  '307': 'map-marker',
  '308': 'map-o',
  '309': 'map-pin',
  '310': 'map-signs',
  '311': 'meh-o',
  '312': 'microchip',
  '313': 'microphone',
  '314': 'microphone-slash',
  '315': 'minus',
  '316': 'minus-circle',
  '317': 'minus-square',
  '318': 'minus-square-o',
  '319': 'mobile',
  '320': 'mobile-phone',
  '321': 'money',
  '322': 'moon-o',
  '323': 'mortar-board',
  '324': 'motorcycle',
  '325': 'mouse-pointer',
  '326': 'music',
  '327': 'navicon',
  '328': 'newspaper-o',
  '329': 'object-group',
  '330': 'object-ungroup',
  '331': 'paint-brush',
  '332': 'paper-plane',
  '333': 'paper-plane-o',
  '334': 'paw',
  '335': 'pencil',
  '336': 'pencil-square',
  '337': 'pencil-square-o',
  '338': 'percent',
  '339': 'phone',
  '340': 'phone-square',
  '341': 'photo',
  '342': 'picture-o',
  '343': 'pie-chart',
  '344': 'plane',
  '345': 'plug',
  '346': 'plus',
  '347': 'plus-circle',
  '348': 'plus-square',
  '349': 'plus-square-o',
  '350': 'podcast',
  '351': 'power-off',
  '352': 'print',
  '353': 'puzzle-piece',
  '354': 'qrcode',
  '355': 'question',
  '356': 'question-circle',
  '357': 'question-circle-o',
  '358': 'quote-left',
  '359': 'quote-right',
  '360': 'random',
  '361': 'recycle',
  '362': 'refresh',
  '363': 'registered',
  '364': 'remove',
  '365': 'reorder',
  '366': 'reply',
  '367': 'reply-all',
  '368': 'retweet',
  '369': 'road',
  '370': 'rocket',
  '371': 'rss',
  '372': 'rss-square',
  '373': 's15',
  '374': 'search',
  '375': 'search-minus',
  '376': 'search-plus',
  '377': 'send',
  '378': 'send-o',
  '379': 'server',
  '380': 'share',
  '381': 'share-alt',
  '382': 'share-alt-square',
  '383': 'share-square',
  '384': 'share-square-o',
  '385': 'shield',
  '386': 'ship',
  '387': 'shopping-bag',
  '388': 'shopping-basket',
  '389': 'shopping-cart',
  '390': 'shower',
  '391': 'sign-in',
  '392': 'sign-language',
  '393': 'sign-out',
  '394': 'signal',
  '395': 'signing',
  '396': 'sitemap',
  '397': 'sliders',
  '398': 'smile-o',
  '399': 'snowflake-o',
  '400': 'soccer-ball-o',
  '401': 'sort',
  '402': 'sort-alpha-asc',
  '403': 'sort-alpha-desc',
  '404': 'sort-amount-asc',
  '405': 'sort-amount-desc',
  '406': 'sort-asc',
  '407': 'sort-desc',
  '408': 'sort-down',
  '409': 'sort-numeric-asc',
  '410': 'sort-numeric-desc',
  '411': 'sort-up',
  '412': 'space-shuttle',
  '413': 'spinner',
  '414': 'spoon',
  '415': 'square',
  '416': 'square-o',
  '417': 'star',
  '418': 'star-half',
  '419': 'star-half-empty',
  '420': 'star-half-full',
  '421': 'star-half-o',
  '422': 'star-o',
  '423': 'sticky-note',
  '424': 'sticky-note-o',
  '425': 'street-view',
  '426': 'suitcase',
  '427': 'sun-o',
  '428': 'support',
  '429': 'tablet',
  '430': 'tachometer',
  '431': 'tag',
  '432': 'tags',
  '433': 'tasks',
  '434': 'taxi',
  '435': 'television',
  '436': 'terminal',
  '437': 'thermometer',
  '438': 'thermometer-0',
  '439': 'thermometer-1',
  '440': 'thermometer-2',
  '441': 'thermometer-3',
  '442': 'thermometer-4',
  '443': 'thermometer-empty',
  '444': 'thermometer-full',
  '445': 'thermometer-half',
  '446': 'thermometer-quarter',
  '447': 'thermometer-three-quarters',
  '448': 'thumb-tack',
  '449': 'thumbs-down',
  '450': 'thumbs-o-down',
  '451': 'thumbs-o-up',
  '452': 'thumbs-up',
  '453': 'ticket',
  '454': 'times',
  '455': 'times-circle',
  '456': 'times-circle-o',
  '457': 'times-rectangle',
  '458': 'times-rectangle-o',
  '459': 'tint',
  '460': 'toggle-down',
  '461': 'toggle-left',
  '462': 'toggle-off',
  '463': 'toggle-on',
  '464': 'toggle-right',
  '465': 'toggle-up',
  '466': 'trademark',
  '467': 'trash',
  '468': 'trash-o',
  '469': 'tree',
  '470': 'trophy',
  '471': 'truck',
  '472': 'tty',
  '473': 'tv',
  '474': 'umbrella',
  '475': 'universal-access',
  '476': 'university',
  '477': 'unlock',
  '478': 'unlock-alt',
  '479': 'unsorted',
  '480': 'upload',
  '481': 'user',
  '482': 'user-circle',
  '483': 'user-circle-o',
  '484': 'user-o',
  '485': 'user-plus',
  '486': 'user-secret',
  '487': 'user-times',
  '488': 'users',
  '489': 'vcard',
  '490': 'vcard-o',
  '491': 'video-camera',
  '492': 'volume-control-phone',
  '493': 'volume-down',
  '494': 'volume-off',
  '495': 'volume-up',
  '496': 'warning',
  '497': 'wheelchair',
  '498': 'wheelchair-alt',
  '499': 'wifi',
  '500': 'window-close',
  '501': 'window-close-o',
  '502': 'window-maximize',
  '503': 'window-minimize',
  '504': 'window-restore',
  '505': 'wrench',
  '506': 'american-sign-language-interpreting',
  '507': 'asl-interpreting',
  '508': 'assistive-listening-systems',
  '509': 'audio-description',
  '510': 'blind',
  '511': 'braille',
  '512': 'cc',
  '513': 'deaf',
  '514': 'deafness',
  '515': 'hard-of-hearing',
  '516': 'low-vision',
  '517': 'question-circle-o',
  '518': 'sign-language',
  '519': 'signing',
  '520': 'tty',
  '521': 'universal-access',
  '522': 'volume-control-phone',
  '523': 'wheelchair',
  '524': 'wheelchair-alt',
  '525': 'hand-grab-o',
  '526': 'hand-lizard-o',
  '527': 'hand-o-down',
  '528': 'hand-o-left',
  '529': 'hand-o-right',
  '530': 'hand-o-up',
  '531': 'hand-paper-o',
  '532': 'hand-peace-o',
  '533': 'hand-pointer-o',
  '534': 'hand-rock-o',
  '535': 'hand-scissors-o',
  '536': 'hand-spock-o',
  '537': 'hand-stop-o',
  '538': 'thumbs-down',
  '539': 'thumbs-o-down',
  '540': 'thumbs-o-up',
  '541': 'thumbs-up',
  '542': 'ambulance',
  '543': 'automobile',
  '544': 'bicycle',
  '545': 'bus',
  '546': 'cab',
  '547': 'car',
  '548': 'fighter-jet',
  '549': 'motorcycle',
  '550': 'plane',
  '551': 'rocket',
  '552': 'ship',
  '553': 'space-shuttle',
  '554': 'subway',
  '555': 'taxi',
  '556': 'train',
  '557': 'truck',
  '558': 'wheelchair',
  '559': 'wheelchair-alt',
  '560': 'genderless',
  '561': 'intersex',
  '562': 'mars',
  '563': 'mars-double',
  '564': 'mars-stroke',
  '565': 'mars-stroke-h',
  '566': 'mars-stroke-v',
  '567': 'mercury',
  '568': 'neuter',
  '569': 'transgender',
  '570': 'transgender-alt',
  '571': 'venus',
  '572': 'venus-double',
  '573': 'venus-mars',
  '574': 'file',
  '575': 'file-archive-o',
  '576': 'file-audio-o',
  '577': 'file-code-o',
  '578': 'file-excel-o',
  '579': 'file-image-o',
  '580': 'file-movie-o',
  '581': 'file-o',
  '582': 'file-pdf-o',
  '583': 'file-photo-o',
  '584': 'file-picture-o',
  '585': 'file-powerpoint-o',
  '586': 'file-sound-o',
  '587': 'file-text',
  '588': 'file-text-o',
  '589': 'file-video-o',
  '590': 'file-word-o',
  '591': 'file-zip-o',
  '592': 'circle-o-notch',
  '593': 'cog',
  '594': 'gear',
  '595': 'refresh',
  '596': 'spinner',
  '597': 'check-square',
  '598': 'check-square-o',
  '599': 'circle',
  '600': 'circle-o',
  '601': 'dot-circle-o',
  '602': 'minus-square',
  '603': 'minus-square-o',
  '604': 'plus-square',
  '605': 'plus-square-o',
  '606': 'square',
  '607': 'square-o',
  '608': 'cc-amex',
  '609': 'cc-diners-club',
  '610': 'cc-discover',
  '611': 'cc-jcb',
  '612': 'cc-mastercard',
  '613': 'cc-paypal',
  '614': 'cc-stripe',
  '615': 'cc-visa',
  '616': 'credit-card',
  '617': 'credit-card-alt',
  '618': 'google-wallet',
  '619': 'paypal',
  '620': 'area-chart',
  '621': 'bar-chart',
  '622': 'bar-chart-o',
  '623': 'line-chart',
  '624': 'pie-chart',
  '625': 'bitcoin',
  '626': 'btc',
  '627': 'cny',
  '628': 'dollar',
  '629': 'eur',
  '630': 'euro',
  '631': 'gbp',
  '632': 'gg',
  '633': 'gg-circle',
  '634': 'ils',
  '635': 'inr',
  '636': 'jpy',
  '637': 'krw',
  '638': 'money',
  '639': 'rmb',
  '640': 'rouble',
  '641': 'rub',
  '642': 'ruble',
  '643': 'rupee',
  '644': 'shekel',
  '645': 'sheqel',
  '646': 'try',
  '647': 'turkish-lira',
  '648': 'usd',
  '649': 'viacoin',
  '650': 'won',
  '651': 'yen',
  '652': 'align-center',
  '653': 'align-justify',
  '654': 'align-left',
  '655': 'align-right',
  '656': 'bold',
  '657': 'chain',
  '658': 'chain-broken',
  '659': 'clipboard',
  '660': 'columns',
  '661': 'copy',
  '662': 'cut',
  '663': 'dedent',
  '664': 'eraser',
  '665': 'file',
  '666': 'file-o',
  '667': 'file-text',
  '668': 'file-text-o',
  '669': 'files-o',
  '670': 'floppy-o',
  '671': 'font',
  '672': 'header',
  '673': 'indent',
  '674': 'italic',
  '675': 'link',
  '676': 'list',
  '677': 'list-alt',
  '678': 'list-ol',
  '679': 'list-ul',
  '680': 'outdent',
  '681': 'paperclip',
  '682': 'paragraph',
  '683': 'paste',
  '684': 'repeat',
  '685': 'rotate-left',
  '686': 'rotate-right',
  '687': 'save',
  '688': 'scissors',
  '689': 'strikethrough',
  '690': 'subscript',
  '691': 'superscript',
  '692': 'table',
  '693': 'text-height',
  '694': 'text-width',
  '695': 'th',
  '696': 'th-large',
  '697': 'th-list',
  '698': 'underline',
  '699': 'undo',
  '700': 'unlink',
  '701': 'angle-double-down',
  '702': 'angle-double-left',
  '703': 'angle-double-right',
  '704': 'angle-double-up',
  '705': 'angle-down',
  '706': 'angle-left',
  '707': 'angle-right',
  '708': 'angle-up',
  '709': 'arrow-circle-down',
  '710': 'arrow-circle-left',
  '711': 'arrow-circle-o-down',
  '712': 'arrow-circle-o-left',
  '713': 'arrow-circle-o-right',
  '714': 'arrow-circle-o-up',
  '715': 'arrow-circle-right',
  '716': 'arrow-circle-up',
  '717': 'arrow-down',
  '718': 'arrow-left',
  '719': 'arrow-right',
  '720': 'arrow-up',
  '721': 'arrows',
  '722': 'arrows-alt',
  '723': 'arrows-h',
  '724': 'arrows-v',
  '725': 'caret-down',
  '726': 'caret-left',
  '727': 'caret-right',
  '728': 'caret-square-o-down',
  '729': 'caret-square-o-left',
  '730': 'caret-square-o-right',
  '731': 'caret-square-o-up',
  '732': 'caret-up',
  '733': 'chevron-circle-down',
  '734': 'chevron-circle-left',
  '735': 'chevron-circle-right',
  '736': 'chevron-circle-up',
  '737': 'chevron-down',
  '738': 'chevron-left',
  '739': 'chevron-right',
  '740': 'chevron-up',
  '741': 'exchange',
  '742': 'hand-o-down',
  '743': 'hand-o-left',
  '744': 'hand-o-right',
  '745': 'hand-o-up',
  '746': 'long-arrow-down',
  '747': 'long-arrow-left',
  '748': 'long-arrow-right',
  '749': 'long-arrow-up',
  '750': 'toggle-down',
  '751': 'toggle-left',
  '752': 'toggle-right',
  '753': 'toggle-up',
  '754': 'arrows-alt',
  '755': 'backward',
  '756': 'compress',
  '757': 'eject',
  '758': 'expand',
  '759': 'fast-backward',
  '760': 'fast-forward',
  '761': 'forward',
  '762': 'pause',
  '763': 'pause-circle',
  '764': 'pause-circle-o',
  '765': 'play',
  '766': 'play-circle',
  '767': 'play-circle-o',
  '768': 'random',
  '769': 'step-backward',
  '770': 'step-forward',
  '771': 'stop',
  '772': 'stop-circle',
  '773': 'stop-circle-o',
  '774': 'youtube-play',
  '775': '500px',
  '776': 'adn',
  '777': 'amazon',
  '778': 'android',
  '779': 'angellist',
  '780': 'apple',
  '781': 'bandcamp',
  '782': 'behance',
  '783': 'behance-square',
  '784': 'bitbucket',
  '785': 'bitbucket-square',
  '786': 'bitcoin',
  '787': 'black-tie',
  '788': 'bluetooth',
  '789': 'bluetooth-b',
  '790': 'btc',
  '791': 'buysellads',
  '792': 'cc-amex',
  '793': 'cc-diners-club',
  '794': 'cc-discover',
  '795': 'cc-jcb',
  '796': 'cc-mastercard',
  '797': 'cc-paypal',
  '798': 'cc-stripe',
  '799': 'cc-visa',
  '800': 'chrome',
  '801': 'codepen',
  '802': 'codiepie',
  '803': 'connectdevelop',
  '804': 'contao',
  '805': 'css3',
  '806': 'dashcube',
  '807': 'delicious',
  '808': 'deviantart',
  '809': 'digg',
  '810': 'dribbble',
  '811': 'dropbox',
  '812': 'drupal',
  '813': 'edge',
  '814': 'eercast',
  '815': 'empire',
  '816': 'envira',
  '817': 'etsy',
  '818': 'expeditedssl',
  '819': 'fa',
  '820': 'facebook',
  '821': 'facebook-f',
  '822': 'facebook-official',
  '823': 'facebook-square',
  '824': 'firefox',
  '825': 'first-order',
  '826': 'flickr',
  '827': 'font-awesome',
  '828': 'fonticons',
  '829': 'fort-awesome',
  '830': 'forumbee',
  '831': 'foursquare',
  '832': 'free-code-camp',
  '833': 'ge',
  '834': 'get-pocket',
  '835': 'gg',
  '836': 'gg-circle',
  '837': 'git',
  '838': 'git-square',
  '839': 'github',
  '840': 'github-alt',
  '841': 'github-square',
  '842': 'gitlab',
  '843': 'gittip',
  '844': 'glide',
  '845': 'glide-g',
  '846': 'google',
  '847': 'google-plus',
  '848': 'google-plus-circle',
  '849': 'google-plus-official',
  '850': 'google-plus-square',
  '851': 'google-wallet',
  '852': 'gratipay',
  '853': 'grav',
  '854': 'hacker-news',
  '855': 'houzz',
  '856': 'html5',
  '857': 'imdb',
  '858': 'instagram',
  '859': 'internet-explorer',
  '860': 'ioxhost',
  '861': 'joomla',
  '862': 'jsfiddle',
  '863': 'lastfm',
  '864': 'lastfm-square',
  '865': 'leanpub',
  '866': 'linkedin',
  '867': 'linkedin-square',
  '868': 'linode',
  '869': 'linux',
  '870': 'maxcdn',
  '871': 'meanpath',
  '872': 'medium',
  '873': 'meetup',
  '874': 'mixcloud',
  '875': 'modx',
  '876': 'odnoklassniki',
  '877': 'odnoklassniki-square',
  '878': 'opencart',
  '879': 'openid',
  '880': 'opera',
  '881': 'optin-monster',
  '882': 'pagelines',
  '883': 'paypal',
  '884': 'pied-piper',
  '885': 'pied-piper-alt',
  '886': 'pied-piper-pp',
  '887': 'pinterest',
  '888': 'pinterest-p',
  '889': 'pinterest-square',
  '890': 'product-hunt',
  '891': 'qq',
  '892': 'quora',
  '893': 'ra',
  '894': 'ravelry',
  '895': 'rebel',
  '896': 'reddit',
  '897': 'reddit-alien',
  '898': 'reddit-square',
  '899': 'renren',
  '900': 'resistance',
  '901': 'safari',
  '902': 'scribd',
  '903': 'sellsy',
  '904': 'share-alt',
  '905': 'share-alt-square',
  '906': 'shirtsinbulk',
  '907': 'simplybuilt',
  '908': 'skyatlas',
  '909': 'skype',
  '910': 'slack',
  '911': 'slideshare',
  '912': 'snapchat',
  '913': 'snapchat-ghost',
  '914': 'snapchat-square',
  '915': 'soundcloud',
  '916': 'spotify',
  '917': 'stack-exchange',
  '918': 'stack-overflow',
  '919': 'steam',
  '920': 'steam-square',
  '921': 'stumbleupon',
  '922': 'stumbleupon-circle',
  '923': 'superpowers',
  '924': 'telegram',
  '925': 'tencent-weibo',
  '926': 'themeisle',
  '927': 'trello',
  '928': 'tripadvisor',
  '929': 'tumblr',
  '930': 'tumblr-square',
  '931': 'twitch',
  '932': 'twitter',
  '933': 'twitter-square',
  '934': 'usb',
  '935': 'viacoin',
  '936': 'viadeo',
  '937': 'viadeo-square',
  '938': 'vimeo',
  '939': 'vimeo-square',
  '940': 'vine',
  '941': 'vk',
  '942': 'wechat',
  '943': 'weibo',
  '944': 'weixin',
  '945': 'whatsapp',
  '946': 'wikipedia-w',
  '947': 'windows',
  '948': 'wordpress',
  '949': 'wpbeginner',
  '950': 'wpexplorer',
  '951': 'wpforms',
  '952': 'xing',
  '953': 'xing-square',
  '954': 'y-combinator',
  '955': 'y-combinator-square',
  '956': 'yahoo',
  '957': 'yc',
  '958': 'yc-square',
  '959': 'yelp',
  '960': 'yoast',
  '961': 'youtube',
  '962': 'youtube-play',
  '963': 'youtube-square',
  '964': 'ambulance',
  '965': 'h-square',
  '966': 'heart',
  '967': 'heart-o',
  '968': 'heartbeat',
  '969': 'hospital-o',
  '970': 'medkit',
  '971': 'plus-square',
  '972': 'stethoscope',
  '973': 'user-md',
  '974': 'wheelchair',
  '975': 'wheelchair-alt',
}
